import Fetch from "./index";

export const getAvailableModels = async (filters) => {
    const filter = new URLSearchParams(filters).toString();
    return Fetch(`/available-models?${filter}`);
}

export const getMyAvailableModels = async () => {
    return Fetch(`/assistant/available-models`);
}

export const createAvailableModel = async (data) => {
    return Fetch('/available-models', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export const updateAvailableModel = async (id, data) => {
    return Fetch(`/available-models/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export const deleteAvailableModel = async (id) => {
    return Fetch(`/available-models/${id}`, {
        method: 'DELETE'
    });
}
